// Update ClientCard.js to be more flexible
import React, { useEffect, useState } from 'react';
import { Card, Badge } from 'react-bootstrap';
import Icon from '../../../../components/icon/Icon';
import Button from 'components/bootstrap/Button';
import ManageClient from 'pages/Clients/componnents/ManageClient';
import { useLogic } from 'pages/Clients/hooks/useLogic';
import { usePlanningData } from 'pages/planning/hooks/usePlanningData';
import { putAPI } from 'apis/backend/apiNode';
import { COLORS } from 'pages/planning/Mobile';
import SvgMap from 'components/icon/bootstrap/Map';
import { formatPhoneNumber } from 'common/function/functionsUtils';
import { PhoneIcon } from 'assets/customizeIcons/svg-icons';

// Assuming other components like Card, Badge, Button, Icon, ManageClient are imported


const ClientCard = ({ client, isFournisseur = false, setSelectedIntervention, intervention }) => {
	if (!client) {
		return (
			<Card className='border border-light shadow-sm bg-white mb-4'>
				<Card.Body className='py-4 text-center'>
					<div className='text-muted'>
						<Icon icon='PersonOff' size='lg' className='mb-3 opacity-50' />
						<div>{isFournisseur ? 'Aucun fournisseur associé' : 'Aucun client associé'}</div>
					</div>
				</Card.Body>
			</Card>
		);
	}
	const [loading, setLoading] = useState(false);
	const [saved, setSaved] = useState(false);
	const [openCreateModal, setOpenCreateModal] = useState(false);
	const { updateClient } = useLogic();
	const { updateIntervention } = usePlanningData();

	// --- SELECTION STATE ---
	// Default: First shipping address (0) and All phones
	const [selectedShippingIdx, setSelectedShippingIdx] = useState();
	const [selectedPhones, setSelectedPhones] = useState(
		[]
	);

	useEffect(() => {
		if (intervention) {
			console.log("***foundIdx***", intervention.address,)

			// Match Address index
			if (intervention.address && intervention.address) {
				const currentAddr = intervention.address;
				const foundIdx = client.shippingAddresses?.findIndex(
					addr => addr.map_url === currentAddr.map_url
				);

				// If found in client list, use that index, otherwise default to 0
				if (foundIdx !== -1 && foundIdx !== undefined) setSelectedShippingIdx(foundIdx);
			}

			// Match Phones indices
			if (intervention.telephones && intervention.telephones.length > 0) {
				const activeIndices = [];
				client.telephones?.forEach((clientPhone, idx) => {
					if (intervention.telephones.includes(clientPhone)) {
						activeIndices.push(idx);
					}
				});
				// If intervention has phones, use those, otherwise keep all selected
				if (activeIndices.length > 0) setSelectedPhones(activeIndices);
			}
		}
	}, [intervention, client]);

	const handelUpdateClient = async (newData) => {
		const res = await putAPI(`store2000_client`, newData, `/${client?._id}`);
		console.log("res", res)
		// Check if res exists and contains data
		if (!!res?.success && !!res?.client) {
			setSelectedIntervention(res.client);
			setOpenCreateModal(false);
			const payload = {
				address: res.client.shippingAddresses?.[0],
				telephones: res.client.telephones
			};

			await updateIntervention(intervention?._id, payload);

			// Success feedback
			setSaved(true);
			// Optional: alert('Client mis à jour avec succès');
		}
		return (res)
	};
	// --- SAVE ACTION ---
	const handleSaveInterventionData = async () => {
		setLoading(true);
		setSaved(false);

		try {
			const payload = {
				address: client.shippingAddresses?.[selectedShippingIdx],
				telephones: client.telephones?.filter((_, i) => selectedPhones.includes(i))
			};

			await updateIntervention(intervention?._id, payload);

			// Success feedback
			setSaved(true);
			// Hide success message after 3 seconds
			setTimeout(() => setSaved(false), 3000);
		} catch (error) {
			console.error("Erreur lors de la mise à jour:", error);
		} finally {
			setLoading(false);
		}
	};

	const togglePhone = (index) => {
		setSelectedPhones(prev =>
			prev.includes(index) ? prev.filter(i => i !== index) : [...prev, index]
		);
	};

	const getInitials = (name) => (name ? name.substring(0, 2).toUpperCase() : '??');

	const formatPhoneDisplay = (phone) => {
		if (!phone) return null;
		const cleaned = phone.replace(/\D/g, '');
		if (cleaned.length === 10) return cleaned.replace(/(\d{2})(\d{2})(\d{2})(\d{2})(\d{2})/, '$1 $2 $3 $4 $5');
		return phone;
	};


	const entityAddress = (() => {

		if (!client) return '';
		if (
			client.shippingAddresses &&
			client.shippingAddresses.length > 0
		) {
			const address = client.shippingAddresses[0];
			if (address?.formatted) {
				return address.formatted;
			}

			const parts = [];
			if (address?.street) parts.push(address.street);
			if (address?.zip) parts.push(address.zip);
			if (address?.city) parts.push(address.city);
			if (address?.country)
				parts.push(address.country);

			return parts.join(', ');
		}

		return '';

	})();
	console.log("intervention", intervention)

	return (
		<Card className='border border-light shadow-sm bg-white mb-4'>
			<Card.Header className='bg-white border-bottom-0 pt-3 px-4'>
				<div className='d-flex justify-content-between align-items-start w-100'>
					<div className='d-flex align-items-center'>
						<div className='bg-light text-dark rounded-circle d-flex align-items-center justify-content-center fw-bold border me-3' style={{ width: 40, height: 40 }}>
							{getInitials(client.nom)}
						</div>
						<div>
							<h5 className='fw-bold text-dark mb-1'>{client.nom}</h5>
							<div className='d-flex gap-2'>
								<Badge bg='light' text='dark' className='fw-normal border'>
									{client.type === 'particulier' ? 'Particulier' : 'Société'}
								</Badge>
								{client.typeOccupation && (
									<Badge bg='light' text='dark' className='fw-normal border text-capitalize'>
										{client.typeOccupation}
									</Badge>
								)}
							</div>
						</div>
					</div>
					<Button color='primary' size='sm' onClick={() => setOpenCreateModal(true)}>Modifier client</Button>
				</div>
			</Card.Header>

			<Card.Body className='px-4 pt-0'>
				<div className='py-2 border-bottom'>
					<div className='d-flex flex-wrap align-items-center gap-3'>

						<div className='d-flex align-items-center'>
							<Icon icon='Email' size='xs' className='me-2 text-muted' />
							<span className='text-muted  me-2'>Email:</span>
							<span className='fw-medium text-dark'>{client?.emails?.map(email => (email)).join(", ")}</span>
						</div>

					</div>
				</div>

				{!isFournisseur &&
					(client.numeroAppartement || client.interphone || client.codeAcces) && (
						<div className='py-2 border-bottom'>
							<div className='d-flex flex-wrap align-items-center gap-3'>
								{client.numeroAppartement && (
									<div className='d-flex align-items-center'>
										<Icon
											icon='Apartment'
											size='xs'
											className='me-2 text-muted'
										/>
										<span className='text-muted  me-2'>Appt:</span>
										<span className='fw-medium text-dark'>
											{client.numeroAppartement}
										</span>
									</div>
								)}

								{client.interphone && (
									<div className='d-flex align-items-center'>
										<Icon
											icon='Dialpad'
											size='xs'
											className='me-2 text-muted'
										/>
										<span className='text-muted  me-2'>Interphone:</span>
										<span className='fw-medium text-dark'>
											{client.interphone}
										</span>
									</div>
								)}

								{client.codeAcces && (
									<div className='d-flex align-items-center'>
										<Icon icon='Lock' size='xs' className='me-2 text-muted' />
										<span className='text-muted  me-2'>Code:</span>
										<code className='bg-light px-1 rounded border '>
											{client.codeAcces}
										</code>
									</div>
								)}
							</div>
						</div>
					)}

				{/* 1. EMAILS & PERMANENT INFO */}
				<div className='py-2 border-bottom'>
					<div className='d-flex flex-wrap align-items-center gap-3 small'>
						{client.email && (
							<div className='d-flex align-items-center'>
								<Icon icon='Email' size='xs' className='me-2 text-muted' />
								<span className='fw-medium text-dark'>{client.email}</span>
							</div>
						)}
						{client.codeAcces && (
							<div className='d-flex align-items-center'>
								<Icon icon='Lock' size='xs' className='me-2 text-muted' />
								<span className='text-muted me-1'>Code:</span>
								<code className='bg-light px-1 border rounded'>{client.codeAcces}</code>
							</div>
						)}
						{client.interphone && (
							<div className='d-flex align-items-center'>
								<Icon icon='Dialpad' size='xs' className='me-2 text-muted' />
								<span className='text-muted me-1'>Interphone:</span>
								<span className='fw-medium'>{client.interphone}</span>
							</div>
						)}
					</div>
				</div>

				{/* 2. SHIPPING ADDRESS SELECTION (NEW DESIGN) */}
				<div className='py-3 border-bottom'>
					<label className='small fw-bold text-muted mb-2 d-block'>Adresse associée à cette intervention</label>
					<div className='row g-2'>
						{client.shippingAddresses?.map((addr, idx) => (
							<div className='col-12' key={idx}>
								<div
									onClick={() => setSelectedShippingIdx(idx)}
									className={`p-2 border rounded d-flex align-items-center h-100 cursor-pointer transition-all ${selectedShippingIdx === idx ? 'bg-l25-primary' : 'bg-white'}`}
									style={{ cursor: 'pointer', borderLeftWidth: selectedShippingIdx === idx ? '4px' : '1px' }}
								>
									<Icon icon={selectedShippingIdx === idx ? 'RadioButtonChecked' : 'RadioButtonUnchecked'}
										className={`me-2 ${selectedShippingIdx === idx ? 'text-primary' : 'text-muted'}`} />
									<small className='text-dark fw-medium'>
										{addr.street}, {addr.zip} {addr.city}
									</small>
								</div>
							</div>
						))}
					</div>
				</div>

				{/* 3. TELEPHONE SELECTION (SAME DESIGN AS ADDRESS) */}
				<div className='py-3 border-bottom'>
					<label className='small fw-bold text-muted mb-2 d-block'>Numéros associés à cette intervention</label>
					<div className='d-flex flex-wrap gap-2'>
						{client.telephones?.map((phone, idx) => (
							<div
								key={idx}
								onClick={() => togglePhone(idx)}
								className={`p-2 border rounded d-flex align-items-center cursor-pointer ${selectedPhones.includes(idx) ? 'bg-l25-primary' : 'bg-white'}`}
								style={{ cursor: 'pointer', minWidth: '150px' }}
							>
								<Icon icon={selectedPhones.includes(idx) ? 'CheckBox' : 'CheckBoxOutlineBlank'}
									className={`me-2 ${selectedPhones.includes(idx) ? 'text-primary' : 'text-muted'}`} />
								<small className='fw-medium text-dark'>{formatPhoneDisplay(phone)} ({client?.telephones_labels?.[idx]})</small>
							</div>
						))}
					</div>
				</div>

				{/* 4. SAVE BUTTON */}
				<div className='pt-3 d-flex align-items-center justify-content-end gap-3'>
					{/* Success Message */}
					{saved && (
						<span className="text-success small d-flex align-items-center animate__animated animate__fadeIn">
							<Icon icon="CheckCircle" size="xs" className="me-1" />
							Modifications enregistrées !
						</span>
					)}

					<Button
						color='primary'
						onClick={handleSaveInterventionData}
						disabled={loading}
						className="d-flex align-items-center"
					>
						{loading ? (
							<>
								<span className="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
								Enregistrement...
							</>
						) : (
							"Enregistrer pour l'intervention"
						)}
					</Button>
				</div>

				{/* CONTACT SECTION - Refactored for UI/UX */}
				<div style={{ marginTop: 12, padding: '10px', backgroundColor: '#f9fafb', borderRadius: '8px' }}>
					<div style={{ fontWeight: 'bold', color: COLORS.DEFAULT, marginBottom: 5 }}>Adresse affichés au technicien</div>

					{client?.typeOccupation === "locataire" && client?.numeroProprietaire && (

						<ContactRow label="Propriétaire" number={client.numeroProprietaire} color={COLORS.DEFAULT} />



					)}
					{intervention?.telephones?.length > 0 ? (
						intervention.telephones.map((num, idx) => {
							// Find the position of this specific number in the original client list
							const originalIdx = client?.telephones?.indexOf(num);
							// Get the label using that index, fallback to "Tél" if not found
							const labelFromClient = (originalIdx !== -1 && client?.telephones_labels?.[originalIdx]) ? client.telephones_labels[originalIdx] : ""


							return (
								<ContactRow
									key={idx}
									label={"Tél"}
									number={num}
									color={COLORS.DEFAULT}
									label_phone={labelFromClient}

								/>
							);
						})
					) : (
						client?.telephones?.map((num, idx) => (
							<ContactRow
								key={idx}
								label={"Tél"}
								number={num}
								color={COLORS.DEFAULT}
								label_phone={client?.telephones_labels?.[idx]}
							/>
						))
					)}
					<div style={{ display: 'flex', alignItems: 'flex-start', marginTop: 8 }}>
						Adresse :
						<span style={{ marginLeft: 6, color: "#4b5563", fontSize: '13px' }}>
							{intervention?.address?.formatted
								? `${intervention?.address?.formatted}`
								: entityAddress}
						</span>
					</div>

					{
						<div className='mt-2'>
							Zip :
							<span className='fw-bold' style={{ marginLeft: 6, color: "#4b5563", fontSize: '13px' }}>
								{!!intervention?.address?.zip ? intervention?.address?.zip : "?"}
							</span>
						</div>
					}
				</div>

				{openCreateModal && (
					<ManageClient
						setIsOpen={setOpenCreateModal}
						data={client}
						isNewClient={false}
						createClient={handelUpdateClient}
					/>
				)}
			</Card.Body>
		</Card>
	);
};

export const ContactRow = ({ label, number, color, label_phone }) => (
	<div
		style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 4 }}
		onClick={(e) => e.stopPropagation()} // Crucial: prevent opening the card
	>
		<div style={{ fontSize: '13px', color: color }}>
			<span style={{ fontWeight: '500', color: '#6b7280' }}>{label}:</span> {formatPhoneNumber(number)} {!!label_phone && <span className='text-muted small' >({label_phone})</span>}
		</div>

	</div>
);
export default ClientCard;
